import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import ClientSourceForm from './ClientSourceForm';

const ClientSourceActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const ClientSourceEdit = (props: any) => {
  return (
    <Edit actions={<ClientSourceActions {...props} />} {...props}>
      <ClientSourceForm />
    </Edit>
  );
};

export default ClientSourceEdit;
